module.exports = __webpack_public_path__ + "assets/img/2_860_big.d1167adf.jpg";